import { call, put, takeEvery } from 'redux-saga/effects'
import { api } from '../services/api'
import { logRavenError, setUserContext } from '../services/raven'
import { publishTracking } from '../services/tracking'
import {
  FACEBOOK_LOGIN_PENDING,
  FACEBOOK_LOGIN_SUCCESS,
  FACEBOOK_LOGIN_ERROR,
  FACEBOOK_LOGIN_FAIL,
  LOGIN_PENDING_DETAILS,
  CHANGE_AUTH_STATE,
} from '../actions/index'
import constants from '../constants/index'
import sendPostMessage from '../services/post-communication'

function* onFacebookLogin(action) {
  const { payload } = action
  let user

  try {
    if (payload.tokenDetail) {
      user = yield call(api.facebookLogin, { ...payload, providerToken: payload.tokenDetail.accessToken })
    } else if (payload.providerToken) {
      // More details 2nd screen
      user = yield call(api.facebookLogin, {
        terms: payload.terms,
        newsletter: payload.newsletter,
        providerToken: payload.providerToken,
        email: payload.email,
      })
    }

    if (user.status === 202) {
      yield put({ type: LOGIN_PENDING_DETAILS, payload: user })
    } else if (user.status === 201) {
      yield put({ type: FACEBOOK_LOGIN_SUCCESS, payload: user })
      yield put({ type: CHANGE_AUTH_STATE, payload: user.data })

      if (!payload.isRedirectFlow) {
        yield call(sendPostMessage, {
          ...user.data,
          ...constants.USER_ACTIONS.login,
          loginMethod: 'facebook',
        })

        publishTracking({
          clientId: JSON.parse(user.config.data).client_id,
          userAction: 'sign in',
          origin: 'facebook',
          event: 'event44',
        })
      }

      yield call(setUserContext, { email: user.data.email })
    }
  } catch (e) {
    yield put({ type: FACEBOOK_LOGIN_FAIL, payload: e.response })

    if (!payload.isRedirectFlow) {
      publishTracking({
        userAction: 'login error',
        origin: 'facebook',
        event: 'event147',
      })
    }
  }
}

function* onFacebookError(action) {
  yield put({
    type: FACEBOOK_LOGIN_FAIL,
    payload: {
      data: {
        errors: [action.payload.error_description],
      },
    },
  })

  yield call(logRavenError, 'FB login error', action)

  publishTracking({
    userAction: 'login error',
    origin: 'facebook',
    event: 'event147',
  })
}

export function* facebookLogin() {
  yield takeEvery(FACEBOOK_LOGIN_PENDING, onFacebookLogin)
}

export function* facebookLoginError() {
  yield takeEvery(FACEBOOK_LOGIN_ERROR, onFacebookError)
}



// WEBPACK FOOTER //
// ./src/sagas/facebook.js